import { useTranslation } from 'react-i18next';

const TONE = {
  AWAITING_APPROVAL: '#e9a23b', PENDING: '#2a6f97', CONFIRMED: '#2a6f97', IN_PROGRESS: '#2a6f97',
  COMPLETED: '#2f9e44', CANCELLED: '#94a3b8', REJECTED: '#d64550',
};

/** Simple horizontal bar breakdown of bookings by status. */
export default function Analytics({ byStatus = {} }) {
  const { t } = useTranslation();
  const entries = Object.entries(byStatus);
  const total = entries.reduce((s, [, n]) => s + n, 0) || 1;

  return (
    <div className="card pad stack">
      <strong>{t('admin.bookingsByStatus')}</strong>
      {entries.every(([, n]) => n === 0) ? (
        <p className="muted" style={{ fontSize: '.9rem' }}>{t('common.nothingHere')}</p>
      ) : (
        entries.map(([k, n]) => (
          <div key={k}>
            <div className="spread" style={{ fontSize: '.85rem', marginBottom: '.2rem' }}>
              <span>{t(`booking.status.${k}`, { defaultValue: k })}</span>
              <span className="muted">{n}</span>
            </div>
            <div style={{ background: 'var(--line)', borderRadius: 500, height: 8 }}>
              <div style={{
                width: `${(n / total) * 100}%`, background: TONE[k] || 'var(--blue)',
                height: 8, borderRadius: 500, minWidth: n ? 4 : 0,
              }} />
            </div>
          </div>
        ))
      )}
    </div>
  );
}
